module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li ms-value=\''+
((__t=(id ))==null?'':_.escape(__t))+
'\'>'+
((__t=(name ))==null?'':_.escape(__t))+
'</li>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./receipt/templates/group_list_item.html
// module id = 320
// module chunks = 0